import { z } from "zod";

export const inviteUserSchema = z.object({
  email: z.email({ message: "Please enter a valid email address" }),
});

export type InviteUserFormData = z.infer<typeof inviteUserSchema>;
